import React from "react";

import SearchBoxDropdown, {
  SearchBoxDropdownProps,
  SelectedItemHandler,
} from "react-lib/appcon/common/SearchBoxDropdown";

import { SubAssistantsInputProps } from "react-lib/apps/HISV3/ORM/SubAssistantsInput";

/* ------------------------------------------------------ */
/*                    SearchBoxWithKey;                   */
/* ------------------------------------------------------ */
type SearchBoxWithKeyProps = Pick<
  SearchBoxDropdownProps,
  | "clearable"
  | "defaultText"
  | "disabled"
  | "dropdownStyle"
  | "error"
  | "id"
  | "inline"
  | "limit"
  | "loading"
  | "mapOptions"
  | "onAdditionalUrlParams"
  | "onBlur"
  | "onFocus"
  | "placeholder"
  | "selectedItem"
  | "size"
  | "text"
  | "toDisplay"
  | "type"
  | "valueKey"
> &
  Pick<SubAssistantsInputProps, "isDetail" | "onEvent" | "role" | "searchedItemListWithKey"> & {
    width?: string;
    setSelected?: SelectedItemHandler;
  };

const SearchBoxWithKey = (props: SearchBoxWithKeyProps) => {
  const handleSelect: SelectedItemHandler = (value, key, data) => {
    let updatedValue = value;

    if (props.isDetail) {
      const searchKey = `${props.type}_${props.id}`;
      const items: Record<string, any>[] = props.searchedItemListWithKey?.[searchKey] || [];
      const detail = items.find((item: any) => item.id === value);

      updatedValue = detail
        ? {
            id: detail.id,
            name_code: detail.name_code,
          }
        : null;
    }

    return props.setSelected?.(updatedValue, key, data);
  };

  return (
    <SearchBoxDropdown
      // disabled={selectedManagePatient !== null}
      onEvent={props.onEvent}
      id={props.id?.toString()}
      style={{ width: props.width || "100%" }}
      boxStyle={{ width: props.width || "100%" }}
      clearable={props.clearable}
      defaultText={props.defaultText}
      disabled={props.disabled}
      dropdownStyle={props.dropdownStyle}
      error={props.error}
      icon="search"
      inline={props.inline}
      label=""
      limit={props.limit}
      loading={props.loading}
      placeholder={props.placeholder}
      role={props.role}
      selectedItem={props.selectedItem}
      size={props.size}
      toDisplay={props.toDisplay}
      type={props.type}
      valueKey={props.valueKey}
      fluid
      useWithKey
      // searchedItemList={props.searchedItemList}
      searchedItemListWithKey={props.searchedItemListWithKey}
      mapOptions={props.mapOptions}
      setSelectedItem={handleSelect}
      onAdditionalUrlParams={props.onAdditionalUrlParams}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
    />
  );
};

SearchBoxWithKey.displayName = "SearchBoxWithKey";

export default React.memo(SearchBoxWithKey);
